import Index from './index.vue'
// import Create from './components/Create.vue'
import List from './components/List.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'classRoom',
    name: 'classRoom',
    component: Index,
    title: 'Class Room',
    redirect: { name: 'class-room-list' },
    children: [
      
      {
        path: 'list',
        name: 'class-room-list',
        component: List,
      },
      
    ],
  },
]
